import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import NoIndex from "../NoIndex";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import TopImage from "../../images/Dashboard_IMG.png";
import { Doughnut } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import FacebookLogin from "../Meta_Login/FacebookLogin";
import FacebookLogintwo from "../Meta_Login/FacebookLogin2";
import { Wallet, RefreshCw, PlusCircle } from "lucide-react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend as ChartLegend,
} from "chart.js";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import MyContext from "../../MyContext";
import { toast } from "react-toastify";

ChartJS.register(ArcElement, ChartTooltip, ChartLegend);
const speed = 75; // Example speed of the bike
const maxSpeed = 100; // Maximum speed value
const semiDonutData = {
  datasets: [
    {
      data: [speed, maxSpeed - speed],
      backgroundColor: [" rgba(46, 141, 251)", "rgba(200, 200, 200, 0.2)"],
      borderColor: [" rgba(46, 141, 251)", "rgba(200, 200, 200, 0.2)"],
      borderWidth: 1,
      cutout: "80%",
      rotation: -90,
      circumference: 180,
    },
  ],
};
const semiDonutOptions = {
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  rotation: -90,
  circumference: 180,
};
const data = [
  { name: "Jan", uv: 1000 },
  { name: "Feb", uv: 3000 },
  { name: "Mar", uv: 2000 },
  { name: "Apr", uv: 2780 },
  { name: "May", uv: 1890 },
  { name: "Jun", uv: 2390 },
  { name: "Feb", uv: 3000 },
  { name: "Mar", uv: 2000 },
  { name: "Apr", uv: 2780 },
  { name: "May", uv: 1890 },
  { name: "Jun", uv: 2390 },
  { name: "Jul", uv: 1000 },
];
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          padding: "10px",
        }}
      >
        <p>{`${label} : ${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};
const data_chat = [
  { name: "Jan", uv: 1500 },
  { name: "Feb", uv: 3000 },
  { name: "Mar", uv: 2000 },
  { name: "Apr", uv: 2780 },
  { name: "May", uv: 1890 },
  { name: "Jun", uv: 2390 },
  { name: "Jul", uv: 1000 },
  { name: "Jan", uv: 1500 },
  { name: "Feb", uv: 3000 },
  { name: "Mar", uv: 2000 },
  { name: "Apr", uv: 2780 },
  { name: "May", uv: 1890 },
  { name: "Jun", uv: 2390 },
  { name: "Jul", uv: 1000 },
];
const CustomTooltip_chat = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          padding: "10px",
        }}
      >
        <p>{`${label} : ${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};
const Dashboard = ({ userID }) => {
  const { baseUrl, config } = useContext(MyContext);
  const [walletBalance, setWalletBalance] = useState("");
  const [dashboardData, setDashboardData] = useState({});
  const [campaignData, setCampaignData] = useState({});
  const [percentage, setPercentage] = useState("");
  const [qrCode, setQrCode] = useState("");
  const [subscriptionDetails, setSubscriptionDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [orderAnalytics, setorderAnalytics] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [interval, setInterval] = useState("30");

  const [showTopupModal, setShowTopupModal] = useState(false);
  const [amount, setAmount] = useState("");

  const storedUser = JSON.parse(sessionStorage.getItem("user")) || {};
  const [totalQuote, setTotalQuote] = useState(0);
  const [sentOnNetwork, setSentOnNetwork] = useState(0);
  const [semiDonutData, setSemiDonutData] = useState({
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ["rgba(46, 141, 251)", "rgba(200, 200, 200, 0.2)"],
        borderColor: ["rgba(46, 141, 251)", "rgba(200, 200, 200, 0.2)"],
        borderWidth: 1,
        cutout: "80%",
        rotation: -90,
        circumference: 180,
      },
    ],
  });

  const handleTopup = async () => {
    if (!amount || Number(amount) <= 0) {
      toast.error("Please enter valid amount");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        userid: userID,
        amount: amount,
        custMobile: storedUser.mobile,
        custName:
          storedUser.username?.trim() || storedUser.mobile || "Customer",
      };

      const res = await axios.post(
        `${baseUrl}/api/Order/generatePaytmIntentAbhi`,
        payload,
        config,
      );

      if (res.data?.responseCode === "00") {
        const paymentUrl = res.data.link;

        if (!paymentUrl) {
          toast.error("Payment URL not received");
          return;
        }

        setShowTopupModal(false);

        window.open(paymentUrl, "_blank");

        setTimeout(() => {
          getWalletBalance();
        }, 5000);
      } else {
        toast.error(res.data?.responseMessage || "Payment failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // API call for Active Plan Section
  const fetchActivePlanData = async () => {
    try {
      const requestbody = {
        userid: userID, // Ensure userID is available
        interval: interval,
      };

      const response = await axios.post(
        `${baseUrl}/api/Campaign/v1.0/getCampaignAnalytics`, // Adjust as per your API
        requestbody,
        config,
      );

      if (response.data.responseCode === "00") {
        setCampaignData(response.data.data);
      } else {
        setCampaignData({
          read: 0,
          accepted: 0,
          delivered: 0,
          sent: 0,
          responded: 0,
          failed: 0,
        });
      }

      setLoading(false); // Stop loading after data is fetched
    } catch (error) {
      console.error("Error fetching active plan data:", error);
      setLoading(false);
    }
  };
  const shareQRCode = async (qrCode) => {
    const message = encodeURIComponent("Scan this QR code to start a chat:");
    const url = encodeURIComponent(qrCode); // Ensure this is a valid image URL

    // WhatsApp Share URL
    const whatsappUrl = `https://wa.me/?text=${message}%20${url}`;

    // Open WhatsApp in a new tab
    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {
    fetchActivePlanData();
  }, [interval]);
  // Semi-donut chart options
  const semiDonutOptions = {
    plugins: {
      legend: {
        display: false, // Hide legend
      },
      tooltip: {
        enabled: false, // Disable tooltips
      },
    },
    rotation: -90, // Ensure it starts from the top
    circumference: 180, // Semi-circle
  };
  const QrCodeApi = async () => {
    try {
      const requestBody = {
        userid: userID,
        secret: "string",
        message: "Hii",
      };
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/getQRCode`,
        requestBody,
        config,
      );
      console.log(response.data.response.qr_image_url);
      if (response.data.responseCode === "00") {
        setQrCode(response.data.response.qr_image_url);
      }
    } catch {}
  };
  const downloadQRCode = (qrCodeUrl) => {
    const link = document.createElement("a");
    link.href = qrCodeUrl;
    link.download = "QRCode.png"; // Name of the file to be downloaded
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const dashboardAPI = async () => {
    try {
      const requestbody = {
        userid: userID,
        interval: interval,
      };

      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/getDashboardAnalytics`,
        requestbody,
        config,
      );

      if (response.data.responseCode === "00") {
        const {
          sentOnNetwork,
          interested,
          notInterested,
          totalSent,
          totalDelivered,
          totalRead,
          totalReplied,
          totalFailed,
          totalAmoutSpent,
          totalQuote,
        } = response.data.data;

        const remainingMessages = totalQuote - sentOnNetwork;

        // Store the data in state
        setDashboardData({
          sentOnNetwork,
          interested,
          notInterested,
          totalSent,
          totalDelivered,
          totalRead,
          totalReplied,
          totalFailed,
          totalAmoutSpent,
          totalQuote,
          remainingMessages,
        });

        // Update chart data
        setSemiDonutData({
          labels: ["Sent Messages", "Available Messages"],
          datasets: [
            {
              data: [sentOnNetwork, remainingMessages],
              backgroundColor: ["#FF6384", "rgba(46, 141, 251)"],
              hoverBackgroundColor: ["#FF6384", "rgba(46, 141, 251)"],
            },
          ],
        });
      } else {
        console.error("Error: Response code is not 00");
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };
  const orderAPI = async () => {
    try {
      const requestbody = {
        userid: userID,
        secret: "string",
      };
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/v1.0/getTemplateAnalytics`,
        requestbody,
        config,
      );

      if (response.data.responseCode === "00") {
        setorderAnalytics(response.data.response);
      } else {
        setorderAnalytics({
          read: 0,
          accepted: 0,
          delivered: 0,
          sent: 0,
          responded: 0,
          failed: 0,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dashboardAPI();
    QrCodeApi();
    // orderAPI();
  }, [interval]);
  useEffect(() => {
    orderAPI();
  }, []);

  const getWalletBalance = async () => {
    try {
      var raw = JSON.stringify({
        userid: userID,
        secret: "string",
      });

      var requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/getParentWallet`,
        requestOptions,
        config,
      );
      const data = await res.json();

      if (data?.responseCode === "00") {
        setWalletBalance(Number(data?.data.wl_balance));
      }
    } catch (error) {
      console.error("Error fetching ledger data:", error);
    }
  };
  useEffect(() => {
    getWalletBalance();
  }, []);

  useEffect(() => {
    if (
      !loading &&
      dashboardData.sent_to_network !== undefined &&
      dashboardData.not_sent_to_network !== undefined
    ) {
      const donut = document.getElementById("donut-chart");
      const total =
        parseInt(dashboardData.sent_to_network) +
        parseInt(dashboardData.not_sent_to_network);
      setPercentage(total);
      const donutFill = (dashboardData.sent_to_network / total) * 440;
      donut.style.strokeDasharray = `${donutFill} 440`;
    }
  }, [dashboardData, loading]);

  const dashboardData1 = {
    total_requests: 358,
    approved: 180,
    pending: 150,
    rejected: 28,
  };
  const total =
    dashboardData1.approved + dashboardData1.pending + dashboardData1.rejected;
  const approvedPercentage = (dashboardData1.approved / total) * 100;
  const pendingPercentage = (dashboardData1.pending / total) * 100;
  const rejectedPercentage = (dashboardData1.rejected / total) * 100;

  const circleCircumference = 2 * Math.PI * 80;
  const approvedDashArray = `${
    (approvedPercentage / 100) * circleCircumference
  } ${circleCircumference}`;
  const pendingDashArray = `${
    (pendingPercentage / 100) * circleCircumference
  } ${circleCircumference}`;
  const rejectedDashArray = `${
    (rejectedPercentage / 100) * circleCircumference
  } ${circleCircumference}`;
  const [selectedInterval, setSelectedInterval] = useState("7");

  const dummyData = [
    {
      id: 1,
      name: "N/A",
      consumption: "N/A",
      ordersSold: "N/A",
      dailyOrders: "N/A",
    },
    {
      id: 2,
      name: "N/A",
      consumption: "N/A",
      ordersSold: "N/A",
      dailyOrders: "N/A",
    },
    {
      id: 3,
      name: "N/A",
      consumption: "N/A",
      ordersSold: " N/A",
      dailyOrders: "N/A",
    },
    {
      id: 4,
      name: "N/A",
      consumption: "N/A",
      ordersSold: "N/A",
      dailyOrders: "N/A",
    },
  ];
  const templateData = {
    latest: {
      id: "null",
      status: "null",
    },
    stats: {
      approved: 0,
      pending: 0,
      rejected: 0,
    },
  };

  // Dummy data for order summary
  const orderData = {
    amounts: {
      completed: 15520.0,
      received: 28600.0,
      dispatched: 23040.0,
    },
    counts: {
      completed: 56,
      received: 120,
      dispatched: 56,
    },
  };

  return (
    <>
      <NoIndex />
      <div
        className=" p-3 "
        style={{
          backgroundColor: "#fff",
          fontFamily: "Inter",
        }}
      >
        {/* {JSON.stringify(dashboardData)} */}
        {/* Modal for subscription expiring soon */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Subscription Expiring Soon</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Your subscription plan is about to expire in{" "}
            {subscriptionDetails?.remaining_days} days. Please renew it soon to
            avoid interruption.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                /* Add renewal logic here */
              }}
            >
              Renew Now
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="row col-12 m-0 p-0 d-flex  justify-content-start align-items-start">
          {/* Top Banner */}
          {(userID === "A1001" || userID === "A1031") && (
            <div className="d-flex justify-content-center py-4 pb-5">
              {/* <FacebookLogin/> */}
              {/* <FacebookLogintwo/> */}
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center pb-3">
            <h3 className="CreateCampaign">Dashboard</h3>

            <div className="d-flex align-items-center gap-2">
              {/* Wallet Card */}
              <div className="billing-wallet-card py-2 d-flex align-items-center px-3 me-2">
                <select
                  id="interval"
                  value={interval}
                  onChange={(e) => setInterval(e.target.value)}
                  className="form-select w-auto d-inline-block me-4"
                >
                  <option value="1">Today</option>
                  <option value="7">Last 7 Days</option>
                  <option value="30">Last 30 Days</option>
                  <option value="365">All Time</option>
                </select>

                <span className="me-1">Wallet Balance :</span>

                <span className="text-white fw-bold ">
                  ₹ {(Number(walletBalance) || 0).toFixed(2)}
                </span>
              </div>

              <button
                className="billing-Topup-card wallet-action-height py-2 d-flex align-items-center px-3 me-2"
                onClick={() => {
                  setAmount("");
                  setShowTopupModal(true);
                }}
              >
                <PlusCircle size={16} className="me-2" />
                Topup
              </button>

              <button
                className="billing-Refresh-card wallet-action-height py-2 d-flex align-items-center px-3"
                onClick={getWalletBalance}
              >
                <RefreshCw size={16} className="me-2" />
                Refresh
              </button>
            </div>
          </div>

          <div className="col-12 p-0 m-0  ">
            <div className=" d-flex mx-2 p-0 anlk-animated-gradient border-15-black">
              <div className="anlk-particle-wrapper">
                <div className="anlk-bubble anlk-bubble1"></div>
                <div className="anlk-bubble anlk-bubble2"></div>
                {/* Add more if needed */}
              </div>
              <div className="col-6 p-4">
                <div className="text-top">
                  Integrated Your System with Message Notifier and Maximize All
                  Benefits
                </div>
              </div>
              <div className="col-6 p-0 m-0">
                <div
                  className="d-flex p-0 m-0 justify-content-end align-items-center"
                  style={{ overflow: "hidden", height: "180px" }}
                >
                  <img
                    src={TopImage}
                    height={300}
                    alt=""
                    style={{
                      objectFit: "cover",
                      position: "relative",
                      top: "+80px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 p-0 m-0 ">
            <div className="  mt-3">
              {/* <h2 className="dashboard-campaign-title">Campaign Statistics</h2> */}
              <div className="row col-12 m-0 p-0 d-flex justify-content-between">
                {Object.entries(campaignData).map(([key, value]) =>
                  key === "delivered" ||
                  key === "accepted" ||
                  key === "failed" ? (
                    <div className="col-4 p-0 m-0  " key={key}>
                      <div className="dashboard-campaign-box m-2 border-15-black">
                        <span className="dashboard-campaign-label">
                          {key.toUpperCase()}
                        </span>
                        <span className="dashboard-campaign-value">
                          {value}
                        </span>
                      </div>
                    </div>
                  ) : (
                    ""
                  ),
                )}
              </div>
            </div>
          </div>

          <div className="col-4 m-0 p-0 ">
            {/* Seventh QR */}
            <div className=" p-3 m-2 my-3  bg-white d-flex flex-column  justify-content-between  border-15-black ">
              <div className="row col-12 m-0 p-0">
                <div className="col-8 m-0 p-0">
                  <div className="d-flex justify-content-center align-items-center">
                    <img src={qrCode} alt="" height={200} />
                  </div>
                </div>
                <div className="col-4 m-0 p-0 d-flex flex-column justify-content-center align-items-center">
                  <div className="d-flex justify-content-center">
                    <p className="text-3-2 text-dark text-center">
                      Scan to chat on WhatsApp instantly.
                    </p>
                  </div>
                  <div className="d-flex flex-column justify-content-center gap-2">
                    <button
                      className="blue-button w-100"
                      onClick={() => downloadQRCode(qrCode)}
                    >
                      Download
                    </button>

                    <button
                      className="gray-button w-100"
                      onClick={() => shareQRCode(qrCode)}
                    >
                      Share
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-8 m-0 p-0 ">
            <div className="p-3 m-2 my-3  bg-white d-flex flex-column  justify-content-between  border-15-black ">
              <div className=" w-100  ">
                <div className="p-3">
                  <h6 className="text-dark mb-2">Templates Status</h6>
                  <hr className="m-0 p-0" />
                  <div className="">
                    {" "}
                    <div className="success-alert rounded-2 p-3">
                      <h6 className="mb-1">Hurray!!</h6>
                      <p
                        className="text-muted mb-2"
                        style={{ fontSize: "0.875rem" }}
                      >
                        your latest templates was approved by Meta
                      </p>
                      <div
                        className="d-flex justify-content-between p-2 rounded-2 m-0 align-items-center"
                        style={{ backgroundColor: "#F5F5F5" }}
                      >
                        <span className="text-dark">
                          {orderAnalytics?.lastTemplate}
                        </span>
                        <span
                          className="text-white p-1 rounded-3 px-3"
                          style={{ backgroundColor: "#996be4ff" }}
                        >
                          Total: {orderAnalytics?.total}
                        </span>
                      </div>
                    </div>
                    <div className="mb-3">
                      <p className="text-muted mb-2">
                        Recent Approved Templates
                      </p>
                      <div className="d-flex gap-2">
                        <div className="stat-box bg-success bg-opacity-10 p-2 rounded flex-grow-1">
                          <div className="h5 mb-0 text-dark">
                            {orderAnalytics?.approved}
                          </div>
                          <small className="text-dark">Approved</small>
                        </div>
                        <div className="stat-box bg-warning bg-opacity-10 p-2 rounded flex-grow-1">
                          <div className="h5 mb-0 text-dark">
                            {orderAnalytics?.pending}
                          </div>
                          <small className="textdark">Pending</small>
                        </div>
                        <div className="stat-box bg-danger bg-opacity-10 p-2 rounded flex-grow-1">
                          <div className="h5 mb-0 text-dark">
                            {orderAnalytics?.rejected}
                          </div>
                          <small className="text-dark">Rejected</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-3 ">
                  {" "}
                  <Link
                    to="/WhatsApp/Template"
                    className="text-purple text-decoration-none"
                    style={{ fontSize: "0.875rem" }}
                  >
                    View All Templates
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <circle id="donut-chart" />

      {showTopupModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Topup Wallet</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowTopupModal(false);
                    setAmount("");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <strong>Current Balance:</strong>
                  <div className="text-success fw-bold">
                    ₹ {(Number(walletBalance) || 0).toFixed(2)}
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={
                      storedUser.username || storedUser.mobile || "Customer"
                    }
                    disabled
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Mobile</label>
                  <input
                    type="text"
                    className="form-control"
                    value={storedUser.mobile || ""}
                    disabled
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Enter Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowTopupModal(false);
                    setAmount("");
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={handleTopup}
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Proceed"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
